import { getRootLogger } from 'fe-common-logger-core'
import { getStore, setRootLogger } from '../ddWindow'
import pageLoadDiagnostics from './pageLoadDiagnostics'

const setupLogger = () => {
  const rootLogger = getRootLogger({
    remote: {
      getToken: async () => Promise.resolve(window?.dd?.auth.getToken()?.token || ''),
      data: () => ({
        ...pageLoadDiagnostics.getContext(),
        name: getStore().getState().user.get('userName'),
        organization: getStore().getState().user.get('activeOrganization') ?? 'not-available'
      })
    }
  })
  setRootLogger(rootLogger)
  return rootLogger
}

const rootLogger = setupLogger()

const logger = rootLogger.getLogger('app')

export default logger
